import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { LoadSkeletonComponent } from '../common/load-skeleton/load-skeleton.component';

@Component({
  selector: 'app-table-general-simple',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTooltipModule,
    TranslatePipe,
    LoadSkeletonComponent,
  ],
  templateUrl: './table-general-simple.component.html',
  styleUrl: './table-general-simple.component.scss',
})
export class TableGeneralSimpleComponent {
  headers = input<{ value: string; description: string }[]>([]);
  dataSource = input(new MatTableDataSource<any>());
  isLoading = input(true);
  buttonEvent = input(true);
  checkEvent = input(false);
  hasExpansion = input(false);
  menuButton = input<{
    icon?: string;
    iconFile?: string;
    key: string;
    text: string;
    toolTip?: string;
  }[]>([]);
  highlights = input<Record<string, { color?: string; background?: string }>>({});

  idEmitter = output<number>();
  elementEmitter = output<any>();
  endElementEmitter = output<{ key: string; element: any }>();

  public emitterButton(id: number, element: any): void {
    this.idEmitter.emit(id);
    this.elementEmitter.emit(element);
  }

  public endEmitter(key: string, element: any): void {
    this.endElementEmitter.emit({ key, element });
  }

  public updateElement(item: any, header: string, event: boolean): void {
    item[header] = event;
  }

  public isBoolean(value: unknown): boolean {
    return typeof value === 'boolean';
  }

  public getActionColorClass(key: string): string {
    switch (key) {
      case 'delete':
        return 'action-btn--danger';
      case 'edit':
        return 'action-btn--warning';
      case 'visibility':
        return 'action-btn--primary';
      default:
        return 'action-btn--primary';
    }
  }

  public getCellStyle(header: string, value: any): Record<string, string> | null {
    const highlight = this.highlights()?.[value];
    if (!highlight) return null;
    const style: Record<string, string> = {};
    if (highlight.color) style['color'] = highlight.color;
    if (highlight.background) style['background-color'] = highlight.background;
    return Object.keys(style).length > 0 ? style : null;
  }

  public hasHighlight(value: any): boolean {
    return !!this.highlights()?.[value];
  }
}
